import type { ReactNode } from 'react'

import clsx from 'clsx'

import { questTotemRootStyleFromBrand } from './questTotemBrandStyle'

import type { QuestShellVariant } from '../model/types'

type QuestTotemShellProps = {
  variant: QuestShellVariant
  logoSrc?: string | null
  brandColor?: string | null
  pageBackgroundImageUrl?: string | null
  header?: ReactNode
  footer?: ReactNode
  children: ReactNode
}

export function QuestTotemShell({
  variant,
  logoSrc,
  brandColor,
  pageBackgroundImageUrl,
  header,
  footer,
  children
}: QuestTotemShellProps) {
  return (
    <div
      className={clsx(
        'flex min-h-dvh flex-col bg-white',
        variant === 'immersive' && 'quest-totem-root--immersive'
      )}
      style={{
        ...questTotemRootStyleFromBrand(brandColor),
        ...(pageBackgroundImageUrl
          ? ({ '--quest-totem-page-bg-image': `url(${pageBackgroundImageUrl})` } as never)
          : {})
      }}
    >
      {header && (
        <header className="flex shrink-0 items-center justify-center p-4">
          {logoSrc && <img src={logoSrc} alt="" className="h-10" />}
          {header}
        </header>
      )}

      <main className="flex flex-1 flex-col items-center justify-center p-4">{children}</main>

      {footer && <footer className="shrink-0 p-4">{footer}</footer>}
    </div>
  )
}
